class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    this.renderVersion = 0;
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
    this.observer.observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    const version = this.renderVersion;
    fetchCartSections(['mini-cart'])
      .then(sections => {
        if (version !== this.renderVersion) return;
        this.innerHTML = this.getSectionInnerHTML(sections['mini-cart']);
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => console.error(e));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  async renderContents(parsedState) {
    const version = ++this.renderVersion;
    this.observer?.disconnect();
    this.productId = parsedState.id;
    const sections = this.getSectionsToRender();
    let rendered = parsedState.sections;
    if (sections.some(section => typeof rendered?.[section.id] !== 'string')) {
      rendered = await fetchCartSections(sections.map(section => section.id));
    }
    const updates = sections.map(section => ({
      element: document.getElementById(section.id),
      html: this.getSectionInnerHTML(rendered[section.id], section.selector)
    }));
    if (version !== this.renderVersion) return;
    updates.forEach(({ element, html }) => {
      if (element) element.innerHTML = html;
    });
    this.open();
    document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
